<template>
    <el-dialog
      :visible.sync="trackingVisible"
      :title="$t('OrdinaryOrderMix.LogisticsTable.TrackingDetails')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="true"
      width="700px"
      style="z-index: 2014"
    >
      <div style="width:100%;height:30px;display: flex;justify-content: space-between;align-items: center;padding-bottom: 20px;">
        <div style="width:45%">{{ $t('OrdinaryOrderMix.LogisticsTable.TrackingNo') }} : {{ trackingId }}</div>
        <div style="width:45%;display: flex;align-items: center;">
          <div style="width:115px">{{ $t('OrdinaryOrderMix.LogisticsTable.ParcelNo') }}</div>  
          <BjSelectLov v-model="ParcelNo" :disabled="disParcel" :placeholder="$t('chooseText')" :option-list="ParcelNoList" @change="getTableData"/>
        </div>
      </div>
      <el-table :data="trackingTableData" stripe border :header-cell-style="$rowStyle.DEFAULT" max-height="500px">
        <!-- <el-table-column type="index" :label="$t('table.countText')" width="60" align="center" /> -->
        <el-table-column :label="$t('OrdinaryOrderMix.LogisticsTable.TrackingStatus')" align="center" prop="lastStatus" width="222"/>
        <el-table-column :label="$t('OrdinaryOrderMix.LogisticsTable.TrackingLocation')" align="center" prop="lastLocation" />
        <el-table-column :label="$t('OrdinaryOrderMix.LogisticsTable.TrackingTime')" align="center" prop="lastLogisDate" >
          <template slot-scope="scope">
            {{ scope.row.lastLogisDate | timeFilters(scope.row.lastLogisDate) }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</template>

<script>
import { afterApi } from '@/api';
export default {
  name: '',
  components: {},
  data() {
    return {
      // 弹框展开状态
      trackingVisible:false,
      // 弹框内数据
      trackingData:{},
      // 物流单号
      trackingId:null,
      // 包裹单号
      ParcelNo:null,
      // 包裹单号 下拉框数据
      ParcelNoList:[],
      // 包裹单号 是否可点击
      disParcel:false,
      // 弹框列表数据
      trackingTableData:[],
    }
  },
  methods:{
    // 获取弹框数据并打开弹窗
    show(row){
      const POSTDATA = {
        trackingId: row.logisticsNo,        // "MP0075680899"
        company: row.logisticsBusinessName  // "FWAY"
      }
      afterApi.getTrackingDetails(POSTDATA).then(res => {
        if(res.code != 200){ return this.$message.error(res.msg)}
        if (res.code == 200 && res.msg == "success") {
          this.trackingData = res.data
          this.trackingId = res.data.trackingId
          // 后端只返回一条数据的时候直接给列表赋值
          if(res.data.trackItems?.length == 1){
            this.disParcel = true
            this.ParcelNo = res.data.trackItems[0]?.articleId
            this.trackingTableData = res.data.trackItems[0]?.items || []
          }else if(res.data.trackItems?.length > 1){
            // 多条数据的时候 先给下拉框赋值 下拉框选完数据后再对列表赋值
            this.ParcelNoList = res.data.trackItems?.map(e=>{
              return {label:e.articleId,value:e.articleId}
            })
            // 默认展示第一条数据
            this.ParcelNo = res.data.trackItems[0]?.articleId
            this.trackingTableData = res.data.trackItems[0]?.items || []
          }else{
            this.disParcel = true
            this.ParcelNo = null
            this.trackingTableData = []
          }
          this.trackingVisible = true
        }
      })
    },
    // 弹窗==》下拉框==》获取列表数据
    getTableData(n,m){
      if(n){
        this.trackingTableData = this.trackingData.trackItems?.find(item => item.articleId === n).items
      }else{
        this.trackingTableData = []
      }
    },
    // 关闭弹窗并清空数据
    handleClose(){
      this.trackingId = null
      this.ParcelNo = null
      this.ParcelNoList = []
      this.trackingVisible = false
    },
  }
}
</script>